<script setup>
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

defineProps({
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  avatarSrc: { type: String, default: '' },
  avatarName: { type: String, default: '' },
  statusLabel: { type: String, default: '' },
  statusTone: {
    type: String,
    default: 'neutral',
    validator: value => ['neutral', 'positive', 'critical'].includes(value),
  },
  statusClass: { type: String, default: '' },
  maxWidth: { type: String, default: 'max-w-[48rem]' },
});

const statusClasses = {
  neutral: 'bg-n-slate-9/10 text-n-slate-11',
  positive: 'bg-n-teal-9/10 text-n-teal-11',
  critical: 'bg-n-ruby-9/10 text-n-ruby-11',
};
</script>

<template>
  <header class="border-b border-n-weak">
    <div class="mx-auto flex w-full flex-col gap-4 px-5 py-4 lg:px-8" :class="maxWidth">
      <div class="min-h-5 text-sm text-n-slate-10">
        <slot name="navigation" />
      </div>

      <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex min-w-0 items-center gap-3.5">
          <Avatar
            :src="avatarSrc"
            :name="avatarName || title"
            :size="44"
            rounded-full
            class="shrink-0"
          />
          <div class="min-w-0">
            <div class="flex flex-wrap items-center gap-2">
              <h1 class="truncate text-xl font-semibold leading-7 text-n-slate-12">
                {{ title }}
              </h1>
              <span
                v-if="statusLabel"
                class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
                :class="statusClass || statusClasses[statusTone]"
              >
                {{ statusLabel }}
              </span>
            </div>
            <p v-if="subtitle" class="mt-0.5 truncate text-sm text-n-slate-10">
              {{ subtitle }}
            </p>
          </div>
        </div>

        <div class="flex flex-wrap items-center gap-2 sm:justify-end">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </header>
</template>
